import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthHTTPService } from '../auth-http';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class FilterStateServiceService {
  private refreshData = new BehaviorSubject<boolean>(false);
  public baseUrl = environment.apiUrl;
  public token = new HttpHeaders().append(
    'Authorization',
    `Bearer ${this.authService.currentUserValue?.token}`
  );
  private filterStates: { [key: string]: any } = {};

  constructor(private authHttpService: AuthHTTPService,
      public httpClient: HttpClient,
      public authService: AuthService) { }

  setFilterState(module: string, state: any) {
    const filterValues = state instanceof Object && state['value'] ? state.value : state;
    this.filterStates[module] = filterValues;
    localStorage.setItem(`filterState_${module}`, JSON.stringify(filterValues));
  }

  getFilterState(module: string): any {
    if (!this.filterStates[module]) {
      const savedState = localStorage.getItem(`filterState_${module}`);
      this.filterStates[module] = savedState ? JSON.parse(savedState) : {};
    }
    return this.filterStates[module];
  }

  clearFilterState(module: string) {
    delete this.filterStates[module]; // Remove from in-memory storage
    localStorage.removeItem(`filterState_${module}`); // Remove from localStorage
  }

  setSavedUserFilter(data:any){
    return this.httpClient.post(this.baseUrl + `UserFilterTable/InsertUserFilterDetails`, data);
  }

  getUserFilterDetailsByUserId(userId: any, tableName: any) {
    return this.httpClient.get(
      this.baseUrl + `UserFilterTable/GetUserFilterDetailsByUserId/${userId}/${tableName}`
    );
  }

  deleteUserFilterByFilterId(filterId:any){
    return this.httpClient.get(
      this.baseUrl + `UserFilterTable/DeleteUserFilter/${filterId}`
      );
    }

}
